module.exports = __webpack_public_path__ + "img/der-grazer.e1b0a8ed.svg";